export default __webpack_public_path__ + "static/media/icon-card-crs-signoff.748ebf57.svg";